import React, { useCallback, useEffect, useState } from 'react';
import Button from 'common/components/elements/buttons/primary';
import './style.scss'
import InformationAndPolicies from 'common/components/modules/information-and-policies/sites';
import PropTypes from 'prop-types'
import Icon from 'common/components/elements/icons';
// import Auth from 'sites/utils/Auth';

const uuuids = [
   'e20348c744d84a33982ec012d774a81c',
];

const Block = ({
   isMemberBanned,
   goToHomePage,
   onClickIntercom,
   data,
   countryBlocked,
   regionBlocked,
   goToSignIn,
}) => {
   const [title, setTitle] = useState('');

   const handleResize = useCallback(() => {

      if((!regionBlocked && !countryBlocked) || isMemberBanned){
         setTitle('Sorry, this page is not available')
         return;
      }
      if(uuuids.includes(data?.site_info?.app_id)){
         setTitle('Sorry, this page is not available');
         return;
      }
      if(window.innerWidth < 768){
         setTitle(`This content is not available <br/> for viewing in ${ data?.site_info?.location?.country  ? `${ !countryBlocked && data?.site_info?.location?.city ? (!regionBlocked ? data?.site_info?.location?.city + ',' : data?.site_info?.location?.city) : '' } <br/> ${ !regionBlocked ? data?.site_info?.location?.country : `` }` : ` the country or the <br/> region that you are currently in` }`)
      } else {
         setTitle(`This content is not available for viewing in <br/> ${ data?.site_info?.location?.country  ? `${ !countryBlocked && data?.site_info?.location?.city ? (!regionBlocked ? data?.site_info?.location?.city + ',' : data?.site_info?.location?.city) : '' } ${ !regionBlocked ? data?.site_info?.location?.country : `` }` : `the country or the region that you are currently in` } `)
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, [handleResize]);

   const getLogo = () => {
      if(data?.site_info?.site_logo) return data.site_info.site_logo;
      return null;
   }

   const showLogo = () => {
      if(uuuids.includes(data?.site_info?.app_id) && (regionBlocked || countryBlocked)){
         return false;
      }
      return true;
   }

   const logo = getLogo();

   return (
      <div className='flex flex-col items-center justify-center w-full h-full site-block-content text-center px-2 mx-auto'>
         <div className='flex flex-col items-center justify-center h-full'>
            {
               showLogo() && (
                  <>
                     {
                        !logo && (
                           <Icon
                              name={ `lock` }
                              color={ `disabled` }
                              size={ `` }
                              className={ `!text-[120px] mb-3` }
                           />
                        )
                     }
                     {
                        logo && (
                           <div className='mb-5 flex items-center'>
                              <img src={ logo } alt='' className=' object-contain object-center w-auto h-14' />
                           </div>
                        )
                     }
                  </>
               )
            }

            <span className='text-major font-semibold text-xl leading-6 dark:text-major-dark w-[343px] md:w-[806px]' dangerouslySetInnerHTML={ { __html: title } } />
            <div className='flex justify-center items-center mt-6 h-9'>
               <Button
                  text='Refresh'
                  onClick={ () => {
                     // window.location.reload()
                     goToHomePage()
                  } }
                  borderRadius='large'
                  textSize='small'
                  primaryColor
                  classNames='h-full px-3.5 py-2 text-start'
                  padding='none'
                  iconName='retry'
                  iconPosition='left'
                  fontIconSize={ 'extraLarge' }
               />
            </div>
            <div className='flex justify-center items-center mt-3 h-9'>
               <Button
                  text='Contact support'
                  onClick={ onClickIntercom }
                  borderRadius='large'
                  textSize='base'
                  primaryColor
                  iconName='help-outline'
                  fontIconSize={ 'extraLarge' }
                  iconPosition='left'
                  backgroundColor='transparent'
                  textColor='major-dark'
                  fontIconColor='major-dark'
                  classNames='h-full px-3 text-start intercom-frontend-error'
                  // classNames='h-full px-3 text-start intercom-frontend-error'
                  padding='none'
               />
            </div>
            {
               regionBlocked && data?.site_info?.allow_blocked_login &&
               <div className='flex justify-center items-center mt-3 h-9'>
                  <Button
                     text='I already have an account - Sign in'
                     onClick={ () => {
                        goToSignIn()
                     } }
                     borderRadius='large'
                     textSize='base'
                     primaryColor
                     classNames='h-full px-3 text-start'
                     padding='none'
                     // iconName='retry'
                     iconPosition='left'
                     backgroundColor='transparent'
                  />
               </div>
            }
         </div>
         <InformationAndPolicies />

      </div>
   );
};

Block.propTypes = {
   goToHomePage: PropTypes.func,
   onClickIntercom: PropTypes.func,
   isMemberBanned: PropTypes.bool,
   data: PropTypes.object,
   countryBlocked: PropTypes.bool,
   regionBlocked: PropTypes.bool,
   goToSignIn: PropTypes.bool,
}

export default Block;
